import logo from "./logo.svg";
import "./App.css";
import Movie from "./components/Movie";
import SearchBar from "./components/SearchBar";

function App() {
  return (
    <div className="App">
      <SearchBar></SearchBar>
    </div>
  );
}

export default App;
